import { Dayjs } from 'dayjs';
import { action, computed, makeObservable } from 'mobx';

import { IFormModel, IFormFieldOptions } from 'stores/interfaces';
import {
  dayJsToServerFormat,
  getDefaultDayjsValue,
  normalizeDateValue,
} from 'utils/date';

import { Entry } from '../Entry';

export type ToServerData = string | null;

/** Модель поля ввода даты для компонентов antd ( завязываем на dayjs )*/
class EntryDate
  extends Entry<Dayjs | null>
  implements IFormModel<string, ToServerData>
{
  constructor(options?: Partial<IFormFieldOptions<Dayjs>>) {
    super({
      ...options,
      defaultValue: options?.defaultValue || getDefaultDayjsValue(),
    });

    makeObservable<EntryDate>(this, {
      toServerFormat: computed,
      fromServerFormat: action,
    });
  }

  /**
   * Возвращает серверный формат значение поле
   * @returns {ToServerData} результат для отправки на сервер
   */
  get toServerFormat(): ToServerData {
    return this.value ? dayJsToServerFormat(this.value) : null;
  }

  /**
   * Заполняет значение поле из серверных данных
   * @param from серверные данные
   */
  fromServerFormat(from: string): void {
    this.setValue(normalizeDateValue(from), { noTouch: true });
    this.unTouch();
  }
}

export default EntryDate;
